// extracted by mini-css-extract-plugin
export var label = "_k1-2";
export var slideContainer = "_k1-0";
export var slider = "_k1-1";